/** Chat Icon with badge */
import { Chat } from '@tunasong/icons'
import type { IconProps } from '@tunasong/icons'
import type { FC } from 'react'
import styles from './chat-badge.module.css'

interface ChatBadgeProps extends IconProps {
  showBadge?: boolean
  numComments: number
}
export const ChatBadge: FC<ChatBadgeProps> = ({ showBadge = true, numComments = 0, ...restProps }) =>
  showBadge ? (
    <span className={styles.wrapper}>
      <Chat {...restProps} />
      {numComments > 0 && (
        <span className={styles.badge}>
          {numComments}
        </span>
      )}
    </span>
  ) : (
    <Chat {...restProps} />
  )
